import { useEffect, useState } from "react";
import SortableTable from "../../components/SortableTable";
import Badge from "../../components/Badge";
import axios from "axios";
import Cookies from "js-cookie";
import * as Yup from "yup";
import validations from "../../config/validation";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import { displayFormatDate } from "../../utils/helpers";
import { API_APPROVE_RAISED_CONCERN } from "../../config/Endpoints";

const RaisedConcernActionModal = ({
  selectedRequest: request,
  fetchConcernRequests,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = Cookies.get("accessToken");

  const formDataInitialState = { status: "", comment: "" };
  const [formData, setFormData] = useState(formDataInitialState);
  const [errors, setErrors] = useState({});
  const [tableData, setTableData] = useState([]);

  const columns = [
    { key: "empName", label: "Employee Name", sortable: false },
    { key: "concernRequest", label: "Raised Concern ", sortable: false },
    { key: "concernDate", label: " Concern Date", sortable: false },
    { key: "totalHours", label: "Total Hours", sortable: true },
    {
      key: "status",
      label: "Status",
      sortable: true,
      render: (item) => (
        <Badge
          type={
            item.status === "PENDING"
              ? "warning"
              : item.status === "REJECTED"
              ? "danger"
              : "success"
          }
          className="text-capitalize"
        >
          {item.status === "PENDING"
            ? "Pending"
            : item.status === "REJECTED"
            ? "Rejected"
            : "Approved"}
        </Badge>
      ),
    },
  ];
  const resetForm = () => {
    setFormData(formDataInitialState);
    setErrors({});
  };

  useEffect(() => {
    if (request) {
      setTableData([
        {
          empName: request.empName,
          concernRequest: request.reason,
          concernDate: displayFormatDate(request.concernDate),
          totalHours: request.totalHour ?? "NA",
          status: request.status ?? "-",
        },
      ]);
    }
  }, [request]);

  const validationSchema = Yup.object().shape({
    comment: validations.COMMENT_VALIDATION.min(
      5,
      "Minimum 5 characters are required."
    ),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await validationSchema.validate(formData, { abortEarly: false });
      const res = await axios.post(
        API_APPROVE_RAISED_CONCERN,
        {
          requestId: request.id,
          status: formData.status,
          comment: formData.comment,
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      toast.success(res.data?.message);
      fetchConcernRequests();

      document.getElementsByClassName("cancel-modal")[0].click();
      setFormData(formDataInitialState);
    } catch (error) {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else if (error.inner) {
        const errs = {};
        error.inner.forEach((e) => (errs[e.path] = e.message));
        setErrors(errs);
      } else {
        toast.error("Something went wrong");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="modal-header">
        <h5 className="modal-title text-center flex">Raised Concern Action</h5>
        <button
          type="button"
          className="btn-close"
          onClick={resetForm}
          data-bs-dismiss="modal"
        ></button>
      </div>

      <div className="modal-body">
        <div className="px-2 py-4">
          <div className="d-grid inputs gap-4">
            <SortableTable columns={columns} data={tableData} />

            {/* Action */}

            <div className="row">
              <div className="col-md-2"></div>

              <div className="col-md-4 pt-1">
                <label className="has-asterisk">Action</label>
              </div>

              <div className="col-md-4">
                <select
                  name="status"
                  className="border"
                  value={formData.status}
                  onChange={handleInputChange}
                  required
                >
                  <option value="" disabled>
                    Select Action
                  </option>
                  <option value="APPROVED">Approve</option>
                  <option value="REJECTED">Reject</option>
                </select>
              </div>

              <div className="col-md-2"></div>
            </div>

            {/* Comment */}

            <div className="row">
              <div className="col-md-2"></div>

              <div className="col-md-4 pt-1">
                <label className="has-asterisk">Comment</label>
              </div>

              <div className="col-md-4">
                <textarea
                  className="border"
                  rows={3}
                  name="comment"
                  value={formData.comment}
                  onChange={handleInputChange}
                  required
                />
                {errors.comment && (
                  <small className="text-danger">{errors.comment}</small>
                )}
              </div>

              <div className="col-md-2"></div>
            </div>
          </div>
          <div className="action text-center mt-5"></div>
        </div>
      </div>

      <div className="modal-footer justify-content-center gap-3">
        <button className="theme-button" type="submit" disabled={isLoading}>
          {isLoading ? (
            <ThreeDots height="20" width="60" color="white" />
          ) : (
            "Submit"
          )}
        </button>
        <button
          type="button"
          className="theme-button bg-grey cancel-modal"
          data-bs-dismiss="modal"
          onClick={resetForm}
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

export default RaisedConcernActionModal;
